.card {
  display: inline-flex;
  flex-direction: column;
  border: 1px solid var(--border);
  border-radius: 1rem;
  background: var(--surface);
  box-shadow: var(--shadow-xl);
  overflow: hidden;
  font-family: var(--font-family-base);
}

.top {
  display: flex;
  align-items: stretch;
}

.body {
  padding: 1.25rem 1.5rem;
}
/* Sidebar (two-month) layout: the month columns carry their own padding and draw the full-height
   divider, so the body wrapper adds none of its own — matching the Figma "Date range menu".
   `display: flex` lets the calendar (and thus each month column's divider) stretch to the full
   row height when the preset sidebar is the taller of the two, so the line reaches the footer. */
.card[data-layout='sidebar'] .body {
  display: flex;
  padding: 0;
}

/* ── Preset sidebar ── */
.presets {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 12rem;
  margin: 0;
  padding: 0.75rem;
  list-style: none;
  border-right: 1px solid var(--border);
}
.preset {
  display: flex;
  width: 100%;
  align-items: center;
  padding: 0.5rem 0.75rem;
  border: 0;
  border-radius: 0.5rem;
  background: transparent;
  color: var(--text-secondary);
  text-align: left;
  cursor: pointer;
  transition: background 150ms ease;
}
.preset:hover {
  background: var(--surface-hover);
}
.preset:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring);
}
.presetActive {
  background: var(--surface-secondary);
  color: var(--text-primary);
}

/* ── Inline range head (one-month range): fields + horizontal preset row above the grid ── */
.inlineHead {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
}
.presetRow {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}
.presetRow .preset {
  width: auto;
  padding: 0.25rem 0.625rem;
}

/* ── Value field(s) ── */
.singleRow {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  width: 100%;
}
.rangeFields {
  display: flex;
  gap: 0.625rem;
  align-items: center;
  width: 100%;
}
.field {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  align-items: center;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--border);
  border-radius: 0.5rem;
  background: var(--surface);
  box-shadow: var(--shadow-xs);
}
.fieldValue {
  overflow: hidden;
  color: var(--text-primary);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fieldPlaceholder {
  overflow: hidden;
  color: var(--text-tertiary);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dash {
  color: var(--text-tertiary);
}

/* ── Footer ── */
.footer {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  padding: 1rem;
  border-top: 1px solid var(--border);
}
.footerFields {
  flex: 1 1 0;
  min-width: 0;
}
.footerActions {
  display: flex;
  gap: 0.75rem;
}
/* Inline layout (single date + one-month range): the two buttons split the full width. */
.card[data-layout='inline'] .footerActions {
  flex: 1 1 0;
}
.card[data-layout='inline'] .action {
  flex: 1 1 0;
}
